import React from 'react';
import Icon from '../../../components/AppIcon';

const StatsOverview = ({ stats }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-6">
      <div className="bg-card rounded-lg border border-border p-4 md:p-6">
        <div className="flex items-center justify-between mb-3">
          <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
            <Icon name="Users" size={24} color="var(--color-primary)" />
          </div>
        </div>
        <p className="text-sm font-caption text-muted-foreground mb-1">Total Personnel</p>
        <p className="text-2xl md:text-3xl font-heading font-semibold text-foreground">
          {stats?.total}
        </p>
      </div>
      <div className="bg-card rounded-lg border border-border p-4 md:p-6">
        <div className="flex items-center justify-between mb-3">
          <div className="w-12 h-12 bg-success/10 rounded-lg flex items-center justify-center">
            <Icon name="CheckCircle" size={24} color="var(--color-success)" />
          </div>
        </div>
        <p className="text-sm font-caption text-muted-foreground mb-1">Available</p>
        <p className="text-2xl md:text-3xl font-heading font-semibold text-foreground">
          {stats?.available}
        </p>
      </div>
      <div className="bg-card rounded-lg border border-border p-4 md:p-6">
        <div className="flex items-center justify-between mb-3">
          <div className="w-12 h-12 bg-warning/10 rounded-lg flex items-center justify-center">
            <Icon name="Clock" size={24} color="var(--color-warning)" />
          </div>
        </div>
        <p className="text-sm font-caption text-muted-foreground mb-1">On Job</p>
        <p className="text-2xl md:text-3xl font-heading font-semibold text-foreground">
          {stats?.onJob}
        </p>
      </div>
      <div className="bg-card rounded-lg border border-border p-4 md:p-6">
        <div className="flex items-center justify-between mb-3">
          <div className="w-12 h-12 bg-muted rounded-lg flex items-center justify-center">
            <Icon name="Moon" size={24} color="var(--color-muted-foreground)" />
          </div>
        </div>
        <p className="text-sm font-caption text-muted-foreground mb-1">Off Duty</p>
        <p className="text-2xl md:text-3xl font-heading font-semibold text-foreground">
          {stats?.offDuty}
        </p>
      </div>
    </div>
  );
};

export default StatsOverview;